module.exports = __webpack_public_path__ + "img/sounds.756e5005.png";